import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TypeForm from './TypeForm';
import { COMMUNITY_DETAIL_TABS } from '../../constants';
import CreateIdentificationCodeTypeService from '../../services/identificationCodeTypes/createIdentificationCodeTypeService';

const EMPTY_TYPE = {};

const NewType = ({
  open,
  id,
  dispatchCreateCommunityIdentificationCodeTypePost,
  createCommunityIdentificationCodeTypeFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateCommunityIdentificationCodeTypePost(
        id,
        body,
        () => {
          navigate(
            `/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`
          );
        },
        t
      ),
    [dispatchCreateCommunityIdentificationCodeTypePost, id, t, navigate]
  );

  if (!open) return null;

  return (
    <TypeForm
      header={t('newIdentificationCodeType')}
      onSubmit={handleSubmit}
      submitProcessing={createCommunityIdentificationCodeTypeFetch.pending}
      returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`}
      cancelRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}`}
      data={EMPTY_TYPE}
    />
  );
};

NewType.propTypes = {
  dispatchCreateCommunityIdentificationCodeTypePost: PropTypes.func.isRequired,
  createCommunityIdentificationCodeTypeFetch: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

NewType.defaultProps = { open: false };

export default CreateIdentificationCodeTypeService(NewType);
